import { render, staticRenderFns } from "./DoneIcon.vue?vue&type=template&id=4c85ee7c&"
import script from "./DoneIcon.vue?vue&type=script&lang=js&"
export * from "./DoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports